//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';
import { map , filter } from "lodash"

//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

//  -- Example ------------------------
const examsInitial = [];




export const exams = (state = examsInitial, action) => {
    switch (action.type) {
        case ActionTypes.exams.createExamsSuccess:
            return [action.payload, ...state];
        case ActionTypes.exams.listExamsSuccess:
            return action.payload;
        case ActionTypes.exams.updateExamsSuccess:
            return map(state,dt=>{
                if(dt.id===action.payload.id){
                    return action.payload;
                }
                return dt;
            })
        case ActionTypes.exams.deleteExamsSuccess:
            return filter(state,dt=>dt.id!==action.payload)
        default:
            return state;
    }
};
